<template>
  <v-navigation-drawer
    v-model="showDrawer"
    class="white app-font-size"
    right
    fixed
    :width="300"
    app
    clipped
  >
    <h2 class="text-xs-center text-center py-6 ml-2">
      {{ $t('roleInstructions.headerText') }}
    </h2>

    <ol v-if="isFlat(roleInstructions)" class="mx-6">
      <li
        v-for="(instruction, index) in roleInstructions"
        :key="index"
      >
        <p>{{ instruction }}</p>
      </li>
    </ol>
    <v-container v-else class="py-0">
      <v-row
        v-for="(instruction, index) in roleInstructions"
        :key="index"
      >
        <v-col class="py-0" >
          <v-container class="pt-0 pb-6">
            <v-row>
              <v-col class="py-0">
                <h3>{{instruction.title}}</h3>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="ml-5 py-1" v-html="instruction.description">{{instruction.description}}</v-col>
            </v-row>
            <v-row>
              <v-col class="ml-5 py-0">
                <ol>
                  <li
                    v-for="(item, itemIndex) in instruction.items"
                    :key="itemIndex"
                    v-html="item"
                    class="py-2"
                  >
                    {{item}}
                  </li>
                </ol>
              </v-col>
            </v-row>
          </v-container>
        </v-col>
      </v-row>
    </v-container>
  </v-navigation-drawer>
</template>

<script>
import RoleType from '@/models/roleType';

export default {
  name: 'PORoleInstructions',
  computed: {
    roleInstructions() {
      switch (this.role) {
        case RoleType.Supplier.key:
          return this.isShippingLabel
            ? this.$t('supplierInstructionsShippingLabel')
            : this.$t('supplierInstructions');
        case RoleType.Merchandiser.key:
        case RoleType.Manager.key:
          return this.$t('merchandiserInstructions');
        case RoleType.WarehouseEmployee.key:
          return this.$t('warehouseEmployeeInstructions');
        default:
          return this.$t('supplierInstructions');
      }
    },
    showDrawer: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit('visibility-changed', val);
      },
    },
  },
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    role: {
      type: String,
      required: true,
    },
    isShippingLabel: {
      type: Boolean,
      required: false,
    },
  },
  methods: {
    isFlat(instructions) {
      return typeof (instructions[0]) === 'string';
    },
  },
};
</script>

<i18n>
{
  "en": {
    "roleInstructions": {
      "headerText": "Instructions"
    }
  }
}
</i18n>
